import { render, staticRenderFns } from "./tab-tips.vue?vue&type=template&id=820b02de&scoped=true&"
import script from "./tab-tips.vue?vue&type=script&lang=ts&"
export * from "./tab-tips.vue?vue&type=script&lang=ts&"
import style0 from "./tab-tips.vue?vue&type=style&index=0&id=820b02de&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "820b02de",
  null
  
)

export default component.exports